import { MutationTree } from "vuex";
import { IAppState } from "./app.inteface";
import { ILoadResponse, ISnackbar, DialogConfig, BlockerConfig, IStaff } from "@/interfaces";

type AppMutationTree = MutationTree<IAppState>;

export const mutations: AppMutationTree = {
  setLoad(state: IAppState, load: ILoadResponse) {
    state.load = load;
  },
  setLogged(state: IAppState, logged: boolean) {
    state.logged = logged;
  },
  setLoading(state: IAppState, loading: boolean) {
    state.loading = loading;
  },
  setSnackbar(state: IAppState, snackbar: ISnackbar) {
    state.snackbar = snackbar;
  },
  setToken(state: IAppState, token: string) {
    localStorage.setItem('token', token);
    state.token = token;
  },
  setExpiredTokenDialog(state: IAppState, value: boolean) {
    state.expiredTokenDialog = value;
	},
	setDialog(state: IAppState, config: DialogConfig){
		state.dialog = config;
	},
	setBlocker(state: IAppState, config: BlockerConfig){
		state.blocker = config;
	},

	refreshTimestampUsers(state: IAppState){
		state.timestampUsers = new Date().getTime().toString();
	},
	refreshTimestampInvoices(state: IAppState){
		state.timestampInvoices = new Date().getTime().toString();
	},
	refreshTimestampCustomers(state: IAppState){
		state.timestampCustomers = new Date().getTime().toString();
	},
	refreshTimestampStaff(state: IAppState){
		state.timestampStaff = new Date().getTime().toString();
	},


	setStaffStatus(state: IAppState, s: IStaff) {

		var arrr = state.load.Staff.filter(u=>u.RecordID==s.RecordID);
		var iof = (arrr!=null && arrr.length>0)
		? state.load.Staff.indexOf(arrr[0])
		: -1;
		var match = (arrr!=null && arrr.length>0)
		? arrr[0]: null;


		/// FIRSTLY REMOVING THE TECH FROM THE LIST.
		if(iof>-1){
			state.load.Staff.splice(iof, 1);
		}

		/// NOTHING ELSE TO DO IF THE USER IS NOT ACTIVE.
		if (!s.IsActive) return;

		/// IF THE USER IS ACTIVE, ADD THE NEW INSTANCE TO THE LIST.
		
		state.load.Staff.push(s);

  },

};
